import * as React from 'react';
import { connect } from 'react-redux';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

import { validateField } from './../contact_form/actions';


@connect(
  (_, { name, value, type, onChange }) => ({ name, value, type, onChange }),
  { validateField }
)
export default class Field extends React.Component {
  static defaultProps = {
    onChange: () => null,
    type: 'input',
    error: false,
    errorState: null,
    label: '',
    validateField: () => null,
    children: null,
    defaultValue: undefined,
    ref: () => null
  };

  static propTypes = {
    validateField: React.PropTypes.func,
    name: React.PropTypes.string.isRequired,
    value: React.PropTypes.string.isRequired,
    onChange: React.PropTypes.func,
    type: React.PropTypes.string,
    errorState: React.PropTypes.string,
    label: React.PropTypes.string.isRequired,
    children: React.PropTypes.arrayOf(React.PropTypes.element),
    defaultValue: React.PropTypes.string,
    ref: React.PropTypes.func
  }

  handleBlur({ target: { name, value } }) {
    const { validateField } = this.props;

    validateField(name, value);
  }

  render() {
    const { name, defaultValue, value, onChange, type, errorState, label, ref } = this.props;

    return (
      <FormGroup validationState={errorState}>
        <ControlLabel>{label}</ControlLabel>
        <FormControl
          componentClass={type}
          name={name}
          value={value}
          onBlur={this.handleBlur.bind(this)}
          onChange={onChange}
          defaultValue={defaultValue}
          inputRef={ref}
        >
          {this.props.children}
        </FormControl>
        <FormControl.Feedback />
      </FormGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/components/field.jsx